/* Notre Histoire – boutique : libellés en français + formulaire de personnalisation */
(function () {
  'use strict';

  /* ---------- 1. Options OwnPrint affichées en français ---------- */
  var MAP = {
    'back engraving': 'Gravure au dos', 'back engraving text': 'Texte au dos', 'plating': 'Finition', 'birthstone': 'Pierre de naissance',
    'without back engraving': 'Sans gravure au dos', 'with back engraving': 'Avec gravure au dos (offerte)',
    '18k rose gold plated': 'Plaqué or rose 18 carats', '18k gold plated': 'Plaqué or 18 carats', 'silver steel': 'Acier argenté',
    'january': 'Janvier', 'february': 'Février', 'march': 'Mars', 'april': 'Avril', 'may': 'Mai', 'june': 'Juin',
    'july': 'Juillet', 'august': 'Août', 'september': 'Septembre', 'october': 'Octobre', 'november': 'Novembre', 'december': 'Décembre'
  };
  function tr(s) {
    var k = s.trim().toLowerCase();
    if (MAP[k]) return MAP[k];
    var c = k.replace(/\s*:$/, '');
    if (c !== k && MAP[c]) return MAP[c] + ' :';
    if (k.indexOf(' / ') > -1) {
      var ok = true, out = s.split(' / ').map(function (p) { var v = MAP[p.trim().toLowerCase()]; if (!v) ok = false; return v; });
      if (ok) return out.join(' / ');
    }
    if (/^(back engraving text|back engraving|plating|birthstone)\s*:/i.test(s.trim())) {
      var i = s.indexOf(':'), a = MAP[s.slice(0, i).trim().toLowerCase()], b = tr(s.slice(i + 1)) || s.slice(i + 1).trim();
      if (a) return a + ' : ' + b;
    }
    return null;
  }
  var observer = null, queued = false;
  function relabel() {
    queued = false;
    if (!document.body) return;
    if (observer) observer.disconnect();
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), n, changes = [];
    while ((n = w.nextNode())) {
      var p = n.parentNode;
      if (!p || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(p.nodeName)) continue;
      var v = n.nodeValue; if (!v || v.length > 120 || !/[a-z]/i.test(v)) continue;
      var t = tr(v); if (t) changes.push([n, v.replace(v.trim(), t)]);
    }
    changes.forEach(function (c) { c[0].nodeValue = c[1]; });
    document.querySelectorAll('input[value*="Should be removed"]').forEach(function (i) { var l = i.closest('label') || i.parentNode; if (l) l.style.display = 'none'; });
    document.querySelectorAll('option[value*="Should be removed"]').forEach(function (o) { o.hidden = true; o.disabled = true; });
    if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(relabel); } }

  /* ---------- 2. Formulaire « Votre site » ---------- */
  function initForm(box) {
    if (box.dataset.nhReady) return; box.dataset.nhReady = '1';
    var fid = box.getAttribute('data-form');

    // idées de raisons
    var ta = box.querySelector('textarea[name="properties[Raisons]"]');
    box.querySelectorAll('.nh-chip').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!ta) return;
        var line = b.getAttribute('data-add'), lines = ta.value.split('\n').map(function (x) { return x.trim(); }).filter(Boolean);
        if (lines.indexOf(line) < 0) lines.push(line);
        ta.value = lines.join('\n'); b.classList.add('is-used');
        ta.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });

    // style choisi depuis la page Exemples (?style=lettre)
    var STY = { lettre: 'Lettre scellée', etoiles: 'Nuit étoilée', jardin: 'Jardin secret', polaroid: 'Album polaroid', cinema: 'Cinéma', minimal: 'Moderne', fun: 'Fun & romantique', gaming: 'Gaming' };
    try {
      var want = STY[new URLSearchParams(location.search).get('style') || ''];
      if (want) box.querySelectorAll('input[name="properties[Style du site]"]').forEach(function (r) { if (r.value === want) r.checked = true; });
    } catch (e) {}

    // photos : autant que l'on veut, chacune avec sa note ; aperçu + compression avant l'envoi
    var pbox = box.querySelector('[data-nh-photos]'), padd = box.querySelector('[data-nh-padd]'), pcount = box.querySelector('[data-nh-pcount]');
    var PMAX = pbox ? (parseInt(pbox.getAttribute('data-max'), 10) || 30) : 0;
    var REQ = !!(pbox && pbox.querySelector('[data-nh-req]'));
    var canDT = false; try { canDT = !!new DataTransfer(); } catch (e) {}
    function rows() { return pbox ? Array.prototype.slice.call(pbox.querySelectorAll('.nh-prow')) : []; }
    function fileOf(r) { var f = r.querySelector('input[type=file]'); return f && f.files && f.files[0]; }
    function renumber() {
      var list = rows(), filled = 0;
      list.forEach(function (r, i) {
        var n = i + 1, inp = r.querySelector('input[type=file]'), note = r.querySelector('textarea'), tile = r.querySelector('.nh-photo'), lab = r.querySelector('.nh-photo-n'), sr = r.querySelector('.nh-pnote .nh-sr'), rm = r.querySelector('.nh-prm');
        inp.name = 'properties[Photo ' + n + ']'; if (note) note.name = 'properties[Note photo ' + n + ']';
        if (i === 0 && REQ) { inp.required = true; inp.removeAttribute('data-nh-opt'); } else { inp.required = false; inp.setAttribute('data-nh-opt', ''); }
        if (lab && !tile.classList.contains('is-error')) lab.textContent = 'Photo ' + n + (n === 1 ? ' · principale' : '');
        if (sr) sr.textContent = 'Note de la photo ' + n;
        if (rm) rm.setAttribute('aria-label', 'Retirer la photo ' + n);
        if (fileOf(r)) filled++;
      });
      if (pcount) pcount.textContent = filled ? filled + (filled > 1 ? ' photos ajoutées' : ' photo ajoutée') + (list.length >= PMAX ? ' : maximum atteint.' : '.') : '';
      if (padd) padd.hidden = list.length >= PMAX && !list.some(function (r) { return !fileOf(r); });
    }
    function handleFile(inp) {
      var f = inp.files && inp.files[0], tile = inp.closest('.nh-photo'), msg = tile.querySelector('.nh-photo-n');
      tile.classList.remove('has-img', 'is-error'); tile.style.backgroundImage = '';
      if (!f) { renumber(); return; }
      if (!/^image\//.test(f.type) && !/\.(heic|heif|jpe?g|png|webp)$/i.test(f.name)) { inp.value = ''; tile.classList.add('is-error'); msg.textContent = 'Choisissez une photo'; renumber(); return; }
      shrink(f).then(function (out) {
        if (out !== f && canDT) { try { var dt = new DataTransfer(); dt.items.add(out); inp.files = dt.files; } catch (e) {} }
        var real = inp.files[0];
        if (real.size > 15 * 1024 * 1024) { inp.value = ''; tile.classList.add('is-error'); msg.textContent = 'Photo trop lourde (15 Mo max)'; renumber(); return; }
        tile.style.backgroundImage = 'url(' + URL.createObjectURL(real) + ')'; tile.classList.add('has-img'); renumber();
      });
    }
    function bindRow(r) {
      var inp = r.querySelector('input[type=file]'), rm = r.querySelector('.nh-prm');
      inp.addEventListener('change', function () { handleFile(inp); });
      if (rm) rm.addEventListener('click', function () {
        if (rows().length > 1) r.remove();
        else { inp.value = ''; var t = r.querySelector('textarea'); if (t) t.value = ''; handleFile(inp); }
        renumber();
      });
    }
    function newRow() {
      var r = document.createElement('div'); r.className = 'nh-prow';
      r.innerHTML = '<label class="nh-photo"><input type="file" accept="image/*" form="' + fid + '" data-nh-opt><span class="nh-plus" aria-hidden="true">+</span><span class="nh-photo-n"></span></label>' +
        '<label class="nh-pnote"><span class="nh-sr"></span><textarea form="' + fid + '" rows="2" maxlength="200" placeholder="Où, quand, le souvenir… (facultatif)" data-nh-opt></textarea></label>' +
        '<button type="button" class="nh-prm">×</button>';
      pbox.appendChild(r); bindRow(r); return r;
    }
    if (pbox) {
      rows().forEach(bindRow);
      var picker = document.createElement('input'); picker.type = 'file'; picker.accept = 'image/*'; picker.multiple = true; picker.hidden = true;
      box.appendChild(picker);
      if (padd) padd.addEventListener('click', function () {
        if (canDT) { picker.value = ''; picker.click(); return; }
        var empty = rows().filter(function (r) { return !fileOf(r); })[0] || (rows().length < PMAX ? newRow() : null);
        renumber(); if (empty) empty.querySelector('input[type=file]').click();
      });
      picker.addEventListener('change', function () {
        Array.prototype.slice.call(picker.files || []).forEach(function (f) {
          var r = rows().filter(function (x) { return !fileOf(x); })[0] || (rows().length < PMAX ? newRow() : null);
          if (!r) return;
          var inp = r.querySelector('input[type=file]');
          try { var dt = new DataTransfer(); dt.items.add(f); inp.files = dt.files; } catch (e) { return; }
          handleFile(inp);
        });
        renumber();
        var last = rows().filter(fileOf).pop(); if (last) { var t = last.querySelector('textarea'); if (t && t.scrollIntoView) last.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      });
      renumber();
    }

    // texte au dos obligatoire si « Avec gravure au dos »
    var back = box.querySelector('input[name="properties[Back engraving text]"]'), backWrap = box.querySelector('.nh-back');
    function backChosen() {
      var r = document.querySelector('input[data-option-name="back engraving"]:checked');
      if (r) return /^with /i.test(r.value);
      var s = document.querySelector('select[name="options[back engraving]"]');
      return s ? /^with /i.test(s.value) : true;
    }
    function syncBack() { if (!back) return; var on = backChosen(); back.required = on; if (backWrap) backWrap.classList.toggle('is-off', !on); }
    syncBack(); document.addEventListener('change', function () { setTimeout(syncBack, 50); });
    new MutationObserver(function () { syncBack(); }).observe(document.querySelector('variant-picker') || document.body, { childList: true, subtree: true });

    // ne pas envoyer les champs facultatifs vides
    document.addEventListener('submit', function (e) {
      if (!e.target || e.target.id !== fid) return;
      var off = [], k = 0;
      rows().forEach(function (r) {
        var inp = r.querySelector('input[type=file]'), t = r.querySelector('textarea');
        if (fileOf(r)) { k++; inp.name = 'properties[Photo ' + k + ']'; if (t) t.name = 'properties[Note photo ' + k + ']'; }
        else if (t && !t.disabled) { t.disabled = true; off.push(t); }
      });
      document.querySelectorAll('[form="' + fid + '"][data-nh-opt]').forEach(function (el) {
        var empty = el.type === 'file' ? !(el.files && el.files.length) : !String(el.value || '').trim();
        if (empty && !el.disabled) { el.disabled = true; off.push(el); }
      });
      setTimeout(function () { off.forEach(function (el) { el.disabled = false; }); renumber(); }, 400);
    }, true);
  }

  function shrink(file) {
    return new Promise(function (res) {
      if (file.size < 1.5 * 1024 * 1024 && /jpe?g|png|webp/i.test(file.type)) return res(file);
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var s = Math.min(1, 2000 / Math.max(img.naturalWidth, img.naturalHeight)), c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
        var ctx = c.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height); ctx.drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) {
          if (!b) return res(file);
          var name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
          try { res(new File([b], name, { type: 'image/jpeg' })); } catch (e) { res(file); }
        }, 'image/jpeg', .86);
      };
      img.onerror = function () { URL.revokeObjectURL(url); res(file); };
      img.src = url;
    });
  }

  function start() {
    relabel();
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    document.querySelectorAll('.nh-perso').forEach(initForm);
    document.addEventListener('shopify:section:load', function () { document.querySelectorAll('.nh-perso').forEach(initForm); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
